


export const addTitle = (title) => {
    document.title = title ? title : 'Blife';
};
